import { FC } from 'react';
import Panel, { PanelProps } from '../../elements/Panel/Panel';

const ExecutiveSummaryPanel: FC<
  React.PropsWithChildren<PanelProps>
> = props => {
  return <Panel height='100%' py={2} px={3} {...props} />;
};

export default ExecutiveSummaryPanel;
